import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import "scss/_login.scss";
import "scss/_registerProfile.scss";
import NumberFormat from "react-number-format";
import logo from "assets/img/brand/lcs_logo.png";
import * as Yup from "yup";

import {
  AvForm,
  AvInput,
  AvCheckbox,
  AvCheckboxGroup,
} from "availity-reactstrap-validation";

import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  Col,
  Button,
  Spinner,
  Alert,
} from "reactstrap";

import {
  FORM_CONSIGNEE,
  FORM_SUPPLIER,
  FORM_SHIPPER,
  FORM_RESELLER,
  FORM_VESSEL_OP,
  MAX_UPLOAD,
} from "../../../actions/constant";

import { roleFetchAll } from "../../../actions/roleAction";
import { kotaFetchSub } from "../../../actions/kotaAction";
import { shipperAdd } from "../../../actions/shipperAction";
import { supplierAdd } from "../../../actions/supplierAction";
import { resellerAdd } from "../../../actions/resellerAction";
import { operatorAdd } from "../../../actions/operatorAction";
import { consigneeAdd } from "../../../actions/consigneeAction";
import { userSourceFetchAll } from "../../../actions/masterUserSourceAction";
import { doRegister, doRegisterCheck } from "actions/authAction";
import { provinsiFetchAll } from "../../../actions/provinsiAction";
import cekKontrak from "./cekKontrak";
import "../Login/login.css";

const companyType = [
  { value: "BUMN", label: "BUMN" },
  { value: "Swasta", label: "Swasta" },
];

const companyStatus = [
  { value: "Pusat", label: "Pusat" },
  { value: "Cabang", label: "Cabang" },
];

const identityCard1 = [
  { value: "KTP", label: "KTP" },
  { value: "SIM", label: "SIM" },
  { value: "Kartu Identitas Lainnya", label: "Kartu Identitas Lainnya" },
];

const identityCard2 = [
  { value: "KTP", label: "KTP" },
  { value: "SIM", label: "SIM" },
  { value: "Kartu Identitas Lainnya", label: "Kartu Identitas Lainnya" },
];

const identityCard3 = [
  { value: "KTP", label: "KTP" },
  { value: "SIM", label: "SIM" },
  { value: "Kartu Identitas Lainnya", label: "Kartu Identitas Lainnya" },
];

class Register extends Component {
  constructor() {
    super();
    this.state = {
      isDetail: false,
      form: "",
      userType: "",
      submitted: false,
      profileSubmitted: false,
      profileData: {},
      accountData: {},
      usery_type_id: "",
      provinsi_id: "",
      kota_id: "",
      npwp: "",
      ktp: "",
      jenis_user: "",
      status_perusahaan: "",
      identify_officer1: "",
      identify_officer2: "",
      identify_officer3: "",
      region_msg: "",
      user_types: [],
      loading: false,
      source: [],
      source_id: "",
      isAgree: false,
      bankAccountCount: 1,
      banks: [
        {
          bank: "",
          number: "",
          name: "",
        },
      ],
      bankStr: "",
      showPassword: false,
      showConfirmPassword: false,
      password: "",
      confirm_password: "",
      passwordStrength: "",
      registrationError: "",
    };

    this.countBank = 0;

    this.handleValid = this.handleValid.bind(this);
    this.handleInvalid = this.handleInvalid.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDetailSubmit = this.handleDetailSubmit.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.handleNPWP = this.handleNPWP.bind(this);
    this.onProvChange = this.onProvChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.doProfileSubmit = this.doProfileSubmit.bind(this);
    this.selectOption = this.selectOption.bind(this);
    this.onKotaChange = this.onKotaChange.bind(this);
    this.onCompanyType = this.onCompanyType.bind(this);
    this.onCompanyStatus = this.onCompanyStatus.bind(this);
    this.onIdentityCard1 = this.onIdentityCard1.bind(this);
    this.onIdentityCard2 = this.onIdentityCard2.bind(this);
    this.onIdentityCard3 = this.onIdentityCard3.bind(this);
    this.addNewBankAccount = this.addNewBankAccount.bind(this);
    this.onBankChange = this.onBankChange.bind(this);
    this.buildBankStr = this.buildBankStr.bind(this);
    this.removeBank = this.removeBank.bind(this);
  }

  removeBank(idx) {
    let bankToSplice = this.state.banks;
    bankToSplice.splice(idx, 1);

    this.setState({
      bankAccountCount: this.state.bankAccountCount - 1,
      banks: bankToSplice,
    });
  }

  buildBankStr() {
    let banks = this.state.banks;
    let bankStr = "";
    let count = 1;

    banks.forEach((bank) => {
      bankStr += `${bank.bank};${bank.number};${bank.name}`;
      if (count !== banks.length) {
        bankStr += "#";
      }
      count++;
    });

    this.setState({
      bankStr: bankStr,
    });
  }

  addNewBankAccount(idx) {
    let newBankBank = {
      bank: "",
      number: "",
      name: "",
    };

    let banks = this.state.banks;
    banks[idx] = newBankBank;

    this.setState({
      bankAccountCount: this.state.bankAccountCount + 1,
      banks: banks,
    });
  }

  onBankChange(e) {
    let name = e.target.name;
    let value = e.target.value;
    let banksState = this.state.banks;
    let bankSplit = name.split("-");
    let key = bankSplit[0];
    let idx = bankSplit[1];

    banksState[idx][key] = value;
    this.setState(banksState);
  }

  componentDidMount() {
    let data = {
      show_on_register: true,
    };
    this.props.roleFetchAll(data);
    this.props.userSourceFetchAll();
    this.props.provinsiFetchAll();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.rolesIsSuccess !== this.props.rolesIsSuccess) {
      if (this.props.roles != null) {
        this.props.roles.data.forEach((item) => {
          let option = {
            value: item.id,
            label: item.usertype,
          };

          this.setState((prevState) => ({
            user_types: prevState.user_types.concat(option),
          }));
        });
      }
    }

    if (prevProps.rolesIsSuccess !== this.props.userSource) {
      if (this.props.userSource.data.length > 0) {
        let arr = [];
        this.props.userSource.data.forEach((item) => {
          let obj = { value: item.id, label: item.source };
          arr.push(obj);
        });

        if (this.state.source.length !== this.props.userSource.data.length) {
          this.setState({ ...this.state, source: arr });
        }
      }
    }

    if (prevProps.shipperIsLoading !== this.props.shipperIsLoading) {
      this.setState({ ...this.state, loading: this.props.shipperIsLoading });
    }

    if (prevProps.supplierIsLoading !== this.props.supplierIsLoading) {
      this.setState({ ...this.state, loading: this.props.supplierIsLoading });
    }

    if (prevProps.resellerIsLoading !== this.props.resellerIsLoading) {
      this.setState({ ...this.state, loading: this.props.resellerIsLoading });
    }

    if (prevProps.consigneeIsLoading !== this.props.consigneeIsLoading) {
      this.setState({ ...this.state, loading: this.props.consigneeIsLoading });
    }

    if (prevProps.operatorIsLoading !== this.props.operatorIsLoading) {
      this.setState({ ...this.state, loading: this.props.operatorIsLoading });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.checkSuccess) {
      let form = nextProps.check_data.data.form;
      let usertype = nextProps.check_data.data.usertype;

      if (!this.state.isDetail) {
        this.setState({
          isDetail: true,
          form: form,
          userType: usertype,
        });
      }
    }

    if (
      nextProps.consigneeIsSuccess ||
      nextProps.supplierIsSuccess ||
      nextProps.shipperIsSuccess ||
      nextProps.resellerIsSuccess ||
      nextProps.operatorIsSuccess
    ) {
      this.props.history.push("/register/success");
    }

    // if (
    //   nextProps.consigneeIsInvalid ||
    //   nextProps.supplierIsInvalid ||
    //   nextProps.shipperIsInvalid ||
    //   nextProps.resellerIsInvalid ||
    //   nextProps.operatorIsInvalid
    // ) {
    //   window.alert("Registrasi Gagal");
    // }
  }

  componentWillUnmount() {
    this.setState({ submitted: false });
  }

  selectOption(option) {
    this.setState({ usery_type_id: option.value });
  }

  selectSource = (option) => {
    this.setState({ source_id: option });
  };

  handleSubmit(event, values) {
    if (this.state.passwordStrength === "lemah") {
      this.setState({
        registrationError:
          "Password terlalu lemah. Harap pilih password yang lebih kuat.",
      });
      return;
    }

    values.usery_type_id = this.state.usery_type_id;
    this.props.doRegisterCheck(values);
    this.setState({ accountData: values });
  }

  handleNPWP(values) {
    this.setState({
      npwp: values,
    });
  }

  handleKTP = (values) => {
    this.setState({
      ktp: values,
    });
  };

  handleAktaPendirian = (values) => {
    this.setState({
      akta_pendirian: values,
    });
  };

  handleTDP = (values) => {
    this.setState({
      tanda_daftar_perusahaan: values,
    });
  };

  handleSKD = (values) => {
    this.setState({
      surat_keterangan_domisili: values,
    });
  };

  handleSPS = (values) => {
    this.setState({
      surat_penunjukan_shipper: values,
    });
  };

  onCancel() {
    this.setState({
      isDetail: false,
      form: "",
      userType: "",
      submitted: false,
      profileSubmitted: false,
      profileData: {},
      accountData: {},
      usery_type_id: "",
      provinsi_id: "",
      kota_id: "",
      jenis_user: "",
      status_perusahaan: "",
      identify_officer1: "",
      identify_officer2: "",
      identify_officer3: "",
      region_msg: "",
    });
  }

  handleFile(event) {
    const target = event.target;
    const value = target.files[0];
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  onProvChange(option) {
    this.setState({
      provinsi_id: option.value,
      kota_id: "",
    });
    this.props.kotaFetchSub("get_propinsi/" + option.value);
  }

  onKotaChange(option) {
    this.setState({ kota_id: option.value });
  }

  onCompanyType(option) {
    this.setState({ jenis_user: option.value });
  }

  onCompanyStatus(option) {
    this.setState({ status_perusahaan: option.value });
  }

  onIdentityCard1(option) {
    this.setState({ identify_officer1: option.value });
  }

  onIdentityCard2(option) {
    this.setState({ identify_officer2: option.value });
  }

  onIdentityCard3(option) {
    this.setState({ identify_officer3: option.value });
  }

  doProfileSubmit(values) {
    if (values.provinsi_id !== "" && values.kota_id !== "") {
      if (this.state.form == FORM_CONSIGNEE) {
        this.props.consigneeAdd(values);
        this.setState({ submitted: true });
      } else if (this.state.form == FORM_SUPPLIER) {
        this.props.supplierAdd(values);
        this.setState({ submitted: true });
      } else if (this.state.form == FORM_RESELLER) {
        this.props.resellerAdd(values);
        this.setState({ submitted: true });
      } else if (this.state.form == FORM_SHIPPER) {
        this.props.shipperAdd(values);
        this.setState({ submitted: true });
      } else if (this.state.form == FORM_VESSEL_OP) {
        this.props.operatorAdd(values);
        this.setState({ submitted: true });
      }
    } else {
      this.setState({ region_msg: "Provinsi dan kota wajib diisi" });
    }
  }

  handleDetailSubmit = async (event, values) => {
    // values.npwp = this.state.npwp;
    values.npwp = "-";
    values.provinsi_id = this.state.provinsi_id;
    values.kota_id = this.state.kota_id;
    values.ktp = this.state.ktp;
    values.foto_ktp = this.state.foto_ktp;

    if (this.state.form == FORM_CONSIGNEE) {
      values.usery_type_id = this.state.accountData.usery_type_id;
      values.email = this.state.accountData.email;
      values.password = this.state.accountData.password;
      values.siup_doc = this.state.siup_doc;
      // values.npwp_doc = this.state.npwp_doc;

      if (this.state.pakta_integritas) {
        values.pakta_integritas = this.state.pakta_integritas;
        values.status_pi = 0;
      }

      // values.form_penjualan = this.state.form_penjualan;
      values.consignee_type = parseInt(values.consignee_type);
      values.source = this.state.source_id.label;
      // values.status_npwp = 0;
      values.status_siup = 0;
      values.status_ktp = 0;
      this.setState({ profileData: values });
    } else if (this.state.form == FORM_SUPPLIER) {
      values.usery_type_id = this.state.accountData.usery_type_id;
      values.email = this.state.accountData.email;
      values.password = this.state.accountData.password;
      values.siup_doc = this.state.siup_doc;
      // values.npwp_doc = this.state.npwp_doc;
      // values.pakta_integritas = this.state.pakta_integritas;
      if (this.state.form_penjualan) {
        values.form_penjualan = this.state.form_penjualan;
        values.status_form_penjualan = 0;
      }
      values.supplier_type = parseInt(values.supplier_type);
      values.source = this.state.source_id.label;
      values.status = 0;
      // values.status_npwp = 0;
      values.status_siup = 0;
      values.status_ktp = 0;
      this.setState({ profileData: values });
    } else if (this.state.form == FORM_RESELLER) {
      values.usery_type_id = this.state.accountData.usery_type_id;
      values.email = this.state.accountData.email;
      values.password = this.state.accountData.password;
      values.siup_doc = this.state.siup_doc;
      // values.npwp_doc = this.state.npwp_doc;
      // values.pakta_integritas = this.state.pakta_integritas;
      if (this.state.pakta_integritas) {
        values.pakta_integritas = this.state.pakta_integritas;
        values.status_pi = 0;
      }
      values.reseller_type = parseInt(values.reseller_type);
      // values.status_npwp = 0;
      values.status_siup = 0;
      values.status_ktp = 0;
      this.setState({ profileData: values });
      values.source = this.state.source_id.label;
    } else if (this.state.form == FORM_SHIPPER) {
      values.usery_type_id = this.state.accountData.usery_type_id;
      values.email = this.state.accountData.email;
      values.password = this.state.accountData.password;
      values.siup_doc = this.state.siup_doc;
      // values.npwp_doc = this.state.npwp_doc;
      values.surat_rekomendasi = this.state.surat_rekomendasi;
      values.logo_perusahaan = this.state.logo_perusahaan;
      values.foto_ttd = this.state.foto_ttd;
      values.identify_officerdoc1 = this.state.identify_officerdoc1;
      values.identify_officerdoc2 = this.state.identify_officerdoc2;
      values.identify_officerdoc3 = this.state.identify_officerdoc3;
      values.jenis_user = this.state.jenis_user;
      values.status_perusahaan = this.state.status_perusahaan;
      values.identify_officer1 = this.state.identify_officer1;
      values.identify_officer2 = this.state.identify_officer2;
      values.identify_officer3 = this.state.identify_officer3;
      values.source = this.state.source_id.label;
      values.akta_pendirian = this.state.akta_pendirian;
      values.akta_pendirian_doc = this.state.akta_pendirian_doc;
      values.tanda_daftar_perusahaan = this.state.tanda_daftar_perusahaan;
      values.tanda_daftar_perusahaan_doc =
        this.state.tanda_daftar_perusahaan_doc;
      values.surat_keterangan_domisili = this.state.surat_keterangan_domisili;
      values.surat_keterangan_domisili_doc =
        this.state.surat_keterangan_domisili_doc;
      values.surat_penunjukan_shipper = this.state.surat_penunjukan_shipper;
      values.surat_penunjukan_shipper_doc =
        this.state.surat_penunjukan_shipper_doc;
      // values.status_npwp = 0;
      values.status_siup = 0;
      values.status_ktp = 0;
      values.status_surat_rekomendasi = 0;
      values.status_akta_pendirian = 0;
      values.status_surat_penunjukan_shipper = 0;
      values.status_tanda_daftar_perusahaan = 0;
      values.status_keterangan_domisili = 0;
      values.status_ktp_officer_1 = 0;
      values.status_ktp_officer_2 = 0;
      values.status_ktp_officer_3 = 0;
      values.status_tanda_tangan = 0;
      this.setState({ profileData: values });
    } else if (this.state.form == FORM_VESSEL_OP) {
      this.buildBankStr();
      values.usery_type_id = this.state.accountData.usery_type_id;
      values.email = this.state.accountData.email;
      values.password = this.state.accountData.password;
      values.siup_doc = this.state.siup_doc;
      // values.npwp_doc = this.state.npwp_doc;
      values.logo_perusahaan = this.state.logo_perusahaan;
      values.foto_ttd = this.state.foto_ttd;
      values.bank_account = this.state.bankStr;
      values.source = this.state.source_id.label;
      // values.status_npwp = 0;
      values.status_siup = 0;
      values.status_ktp = 0;
      values.status_tanda_tangan = 0;
      this.setState({ profileData: values });
    }

    let data = this.state.profileData;

    if (this.state.form === FORM_VESSEL_OP) {
      const res = await cekKontrak(data);
      if (res.status === 200) {
        if (res.data !== null) {
          this.doProfileSubmit(data);
        } else {
          window.alert(res.message);
        }
      } else {
        window.alert(res.message);
      }
    } else {
      this.doProfileSubmit(data);
    }
  };

  handleValid() {
    this.setState({ canSubmit: true });
  }

  handleInvalid() {
    this.setState({ canSubmit: false });
  }

  handleIsAgree = (e) => {
    this.setState({ ...this.state, isAgree: e.target.checked });
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  toggleConfirmPasswordVisibility = () => {
    this.setState((prevState) => ({
      showConfirmPassword: !prevState.showConfirmPassword,
    }));
  };

  evaluatePasswordStrength = (value) => {
    const passwordStrengthRegex = [
      /(?=.*[a-z])/,
      /(?=.*[A-Z])/,
      /(?=.*\d)/,
      /(?=.*[@$!%*?&])/,
    ];

    const strength = passwordStrengthRegex.reduce(
      (count, regex) => count + regex.test(value),
      0
    );

    if (value.length < 8 || strength < 4) {
      return "lemah";
    } else if (value.length <= 8 && strength <= 4 && strength < 6) {
      return "sedang";
    } else {
      return "kuat";
    }
  };

  handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    const strength = this.evaluatePasswordStrength(newPassword);

    this.setState({
      password: newPassword,
      passwordStrength: strength,
      registrationError: "",
    });
  };

  render() {
    const { usery_type_id } = this.state.usery_type_id;

    let btnDisabled = true;

    if (this.state.usery_type_id && this.state.source_id.label) {
      btnDisabled = false;
    }

    if (this.state.isDetail) {
      // if (!this.props.provinsiIsSuccess) {
      //   this.props.provinsiFetchAll();
      // }

      const { provinsi_id } = this.state.provinsi_id;
      const { kota_id } = this.state.kota_id;
      const { jenis_user } = this.state.jenis_user;
      const { status_perusahaan } = this.state.status_perusahaan;
      const { identify_officer1 } = this.state.identify_officer1;
      const { identify_officer2 } = this.state.identify_officer2;
      const { identify_officer3 } = this.state.identify_officer3;
      const { showPassword, showConfirmPassword } = this.state;

      return (
        <div className="form-body">
          <div className="row">
            <div className="img-holder">
              <div className="bg"></div>
              <div className="info-holder">
                <div className="image-center">
                  <img src={logo} width="100" height="50" alt="" />
                </div>
                <h3>Sistem Informasi Tol Laut.</h3>
                <p>Access to the most powerfull tool in this application.</p>
              </div>
            </div>
            <div className="form-holder">
              <div className="form-content">
                <div className="form-items form-profile">
                  <div className="website-logo-inside">
                    <div className="logo">
                      <h1>Data Profile</h1>
                      <p className="mb-0">
                        Lengkapi data profile anda untuk dapat menggunakan
                        aplikasi ini.
                      </p>
                    </div>
                    <div className="page-links mt-4">
                      <a href="/register" className="active">
                        {this.state.userType} Profile
                      </a>
                    </div>
                  </div>

                  {this.props.consigneeIsInvalid && this.state.submitted && (
                    <div className="alert alert-danger">
                      {this.props.consigneeInvalid.message}
                    </div>
                  )}

                  {this.props.supplierIsInvalid && this.state.submitted && (
                    <div className="alert alert-danger">
                      {this.props.supplierInvalid.message}
                    </div>
                  )}

                  {this.props.shipperIsInvalid && this.state.submitted && (
                    <div className="alert alert-danger">
                      {this.props.shipperInvalid.message}
                    </div>
                  )}

                  {this.props.resellerIsInvalid && this.state.submitted && (
                    <div className="alert alert-danger">
                      {this.props.resellerInvalid.message}
                    </div>
                  )}

                  {this.props.operatorIsInvalid && this.state.submitted && (
                    <div className="alert alert-danger">
                      {this.props.operatorInvalid.message}
                    </div>
                  )}

                  <AvForm onValidSubmit={this.handleDetailSubmit}>
                    <Row>
                      <Col xs="12" sm="6" lg="6">
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="fa fa-flag"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <AvInput
                            type="text"
                            name="nama_perusahaan"
                            required
                            placeholder="Nama perusahaan (Wajib diisi)"
                          />
                        </InputGroup>
                      </Col>
                      <Col xs="12" sm="6" lg="6">
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="icon-envelope"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <AvInput
                            type="email"
                            name="email"
                            required
                            placeholder="Email (Wajib diisi)"
                          />
                        </InputGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs="12" sm="6" lg="6">
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="fa fa-map-marker"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <AvInput
                            type="textarea"
                            name="alamat"
                            required
                            placeholder="Alamat (Wajib diisi)"
                          />
                        </InputGroup>
                      </Col>
                      <Col xs="12" sm="6" lg="6">
                        {this.props.provinsiIsSuccess && (
                          <Select
                            name="provinsi_id"
                            className="mb-3"
                            required
                            placeholder="-- Pilih Provinsi (Wajib diisi) --"
                            value={provinsi_id}
                            onChange={this.onProvChange}
                            options={this.props.provinsis.data}
                            id="provinsi_id"
                            inputId="input_provinsi_id"
                            instanceId="instance_provinsi_id"
                          />
                        )}
                        {this.props.kotaIsSuccess && (
                          <Select
                            name="kota_id"
                            required
                            placeholder="-- Pilih Kota (Wajib diisi) --"
                            value={kota_id}
                            onChange={this.onKotaChange}
                            options={this.props.kotas.data}
                            id="kota_id"
                            inputId="input_kota_id"
                            instanceId="instance_kota_id"
                          />
                        )}
                      </Col>
                    </Row>

                    <Row>
                      <Col xs="12" sm="6" lg="6">
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="fa fa-fax"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <AvInput
                            type="text"
                            name="fax"
                            required
                            placeholder="No Fax (Wajib diisi)"
                          />
                        </InputGroup>
                      </Col>
                      <Col xs="12" sm="6" lg="6">
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="fa fa-phone"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <AvInput
                            type="text"
                            name="telp"
                            required
                            placeholder="No Telp (Wajib diisi)"
                          />
                        </InputGroup>
                      </Col>
                    </Row>

                    {this.state.form == FORM_RESELLER && (
                      <div>
                        <Row>
                          <Col xs="6" sm="6" lg="6">
                            <label>Nomor SIUP/NIB</label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-file-text-o"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="siup"
                                placeholder="SIUP"
                              />
                            </InputGroup>
                            <InputGroup className="mb-1">
                              <label>Upload File SIUP/NIB</label>
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                id="file-input"
                                name="siup_doc"
                                placeholder="Upload SIUP"
                                accept="image/jpeg,image/png"
                              />
                            </InputGroup>
                            <span className="color-white mb-3">
                              *JPG/JPEG/PNG/PDF Maksimal {MAX_UPLOAD}
                            </span>
                          </Col>
                          {/* <Col xs="6" sm="6" lg="6">
                            <label>Nomor NPWP</label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-file-text-o"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <NumberFormat
                                className="form-control"
                                format="##.###.###.#-###.###"
                                mask="_"
                                onValueChange={(values) => {
                                  const { formattedValue, value } = values;
                                  this.handleNPWP(formattedValue);
                                }}
                              />
                            </InputGroup>
                            <InputGroup className="mb-1">
                              <label>Upload File NPWP</label>
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                id="file-input"
                                name="npwp_doc"
                                placeholder="Upload NPWP"
                                accept="image/jpeg,image/png"
                              />
                            </InputGroup>
                            <span className="color-white mb-3">
                              *JPG/JPEG/PNG/PDF Maksimal {MAX_UPLOAD}
                            </span>
                          </Col> */}
                        </Row>
                      </div>
                    )}

                    {this.state.form != FORM_RESELLER && (
                      <div>
                        <Row>
                          <Col xs="6" sm="6" lg="6">
                            <label>Nomor SIUP/NIB</label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-file-text-o"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="siup"
                                required
                                placeholder="SIUP (Wajib diisi)"
                              />
                            </InputGroup>
                            {/* <InputGroup className="mb-1">
                              <label>Upload File SIUP (Wajib diisi)</label>
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                id="file-input"
                                name="siup_doc"
                                placeholder="Upload SIUP"
                                accept="image/jpeg,image/png"
                                required
                              />
                            </InputGroup>
                            <span className="color-white mb-3">
                              *JPG/JPEG/PNG/PDF Maksimal {MAX_UPLOAD}
                            </span> */}
                          </Col>
                          <Col>
                            {" "}
                            <InputGroup className="mb-1">
                              <label>Upload File SIUP/NIB (Wajib diisi)</label>
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                id="file-input"
                                name="siup_doc"
                                placeholder="Upload SIUP"
                                accept="image/jpeg,image/png"
                                required
                              />
                            </InputGroup>
                            <span className="color-white mb-3">
                              *JPG/JPEG/PNG/PDF Maksimal {MAX_UPLOAD}
                            </span>
                          </Col>
                          {/* <Col xs="6" sm="6" lg="6">
                            <label>Nomor NPWP (Wajib diisi)</label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-file-text-o"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <NumberFormat
                                className="form-control"
                                format="##.###.###.#-###.###"
                                mask="_"
                                onValueChange={(values) => {
                                  const { formattedValue, value } = values;
                                  this.handleNPWP(formattedValue);
                                }}
                              />
                            </InputGroup>
                            <InputGroup className="mb-1">
                              <label>Upload File NPWP (Wajib diisi)</label>
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                id="file-input"
                                name="npwp_doc"
                                placeholder="Upload NPWP"
                                accept="image/jpeg,image/png"
                                required
                              />
                            </InputGroup>
                            <span className="color-white mb-3">
                              *JPG/JPEG/PNG/PDF Maksimal {MAX_UPLOAD}
                            </span>
                          </Col> */}
                        </Row>
                      </div>
                    )}

                    <div className="mt-3">
                      <Row>
                        <Col xs="6" sm="6" lg="6">
                          <label>Nomor KTP (Wajib diisi)</label>
                          <InputGroup className="mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="fa fa-file-text-o"></i>
                              </InputGroupText>
                            </InputGroupAddon>
                            <NumberFormat
                              className="form-control"
                              // format="##.###.###.#-###.###"
                              // mask="_"
                              onValueChange={(values) => {
                                const { formattedValue, value } = values;
                                this.handleKTP(formattedValue);
                              }}
                            />
                          </InputGroup>
                        </Col>
                        <Col xs="6" sm="6" lg="6">
                          <InputGroup className="mb-1">
                            <label>Upload KTP (Wajib diisi)</label>
                            <AvInput
                              className="file-upload"
                              onChange={this.handleFile}
                              bsSize="xs"
                              type="file"
                              id="file-input"
                              name="foto_ktp"
                              placeholder="Upload KTP"
                              accept="image/jpeg,image/png"
                              required
                            />
                          </InputGroup>
                          <span className="color-white mb-3">
                            *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                          </span>
                        </Col>
                      </Row>
                    </div>

                    {(this.state.form == FORM_SHIPPER ||
                      this.state.form == FORM_VESSEL_OP) && (
                      <Row className="mt-3">
                        <Col xs="12" sm="12" lg="12">
                          <label>Nama Penanda Tangan (Wajib diisi)</label>
                          <AvInput
                            type="text"
                            name="nama_ttd"
                            required
                            placeholder="Nama Penanda Tangan"
                          />
                        </Col>
                        <Col xs="12" sm="12" lg="12">
                          <InputGroup className="mb-1">
                            <label>Foto Tanda Tangan (Wajib diisi)</label>
                            <AvInput
                              className="file-upload"
                              onChange={this.handleFile}
                              bsSize="xs"
                              type="file"
                              id="file-input"
                              name="foto_ttd"
                              placeholder="Upload Penanda Tangan"
                              accept="image/jpeg,image/png"
                              required
                            />
                          </InputGroup>
                          <span className="color-white mb-3">
                            *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                          </span>
                        </Col>
                      </Row>
                    )}

                    {this.state.form == FORM_SHIPPER && (
                      <div>
                        <Row className="mt-3">
                          <Col xs="12" sm="6" lg="6">
                            <Select
                              name="jenis_user"
                              placeholder="-- Pilih Jenis Perusahaan --"
                              value={jenis_user}
                              onChange={this.onCompanyType}
                              options={companyType}
                              id="jenis_user"
                              inputId="input_jenis_user"
                              instanceId="instance_jenis_user"
                            />
                          </Col>
                          <Col xs="12" sm="6" lg="6">
                            <Select
                              name="status_perusahaan"
                              placeholder="-- Pilih Status Perusahaan --"
                              value={status_perusahaan}
                              onChange={this.onCompanyStatus}
                              options={companyStatus}
                              id="status_perusahaan"
                              inputId="input_status_perusahaan"
                              instanceId="instance_status_perusahaan"
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-1 mt-3">
                              <label>Surat Rekomendasi (Wajib diisi)</label>
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                id="file-input"
                                name="surat_rekomendasi"
                                placeholder="Upload Surat Rekomendasi"
                                accept="image/jpeg,image/png"
                                required
                              />
                            </InputGroup>
                            <span className="color-white mb-3">
                              *JPG/JPEG/PNG/PDF Maksimal {MAX_UPLOAD}
                            </span>
                          </Col>
                        </Row>

                        <Row>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-1 mt-3">
                              <label>Logo Perusahaan (Wajib diisi)</label>
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                id="file-input"
                                name="logo_perusahaan"
                                placeholder="Upload Logo Perusahaan"
                                accept="image/jpeg,image/png"
                                required
                              />
                            </InputGroup>
                            <span className="color-white mb-3">
                              *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                            </span>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <div className="page-links mt-4">
                              <a href="#." className="active">
                                Officer 1
                              </a>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-user"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="nama_officer1"
                                required
                                placeholder="Nama Officer 1 (Wajib diisi)"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-phone"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="number"
                                name="telp_officer1"
                                required
                                placeholder="No Telepon Officer 1 (Wajib diisi)"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="12" lg="6">
                            <Select
                              name="identify_officer1"
                              placeholder="-- Pilih Kartu Identitas (Wajib diisi) --"
                              value={identify_officer1}
                              onChange={this.onIdentityCard1}
                              options={identityCard1}
                              id="identify_officer1"
                              inputId="input_identify_officer1"
                              instanceId="instance_identify_officer1"
                            />
                          </Col>
                          <Col xs="12" sm="12" lg="6">
                            <InputGroup>
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                id="file-input"
                                name="identify_officerdoc1"
                                placeholder="Upload Kartu Identitas (Wajib diisi)"
                                accept="image/jpeg,image/png"
                                required
                              />
                            </InputGroup>
                            <span className="color-white mb-3">
                              *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                            </span>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <div className="page-links mt-4">
                              <a href="#." className="active">
                                Officer 2
                              </a>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-user"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="nama_officer2"
                                required
                                placeholder="Nama Officer 2 (Wajib diisi)"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-phone"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="number"
                                name="telp_officer2"
                                required
                                placeholder="No Telepon Officer 2 (Wajib diisi)"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="12" lg="6">
                            <Select
                              name="identify_officer2"
                              placeholder="-- Pilih Kartu Identitas (Wajib diisi) --"
                              value={identify_officer2}
                              onChange={this.onIdentityCard2}
                              options={identityCard2}
                              id="identify_officer2"
                              inputId="input_identify_officer2"
                              instanceId="instance_identify_officer2"
                            />
                          </Col>
                          <Col xs="12" sm="12" lg="6">
                            <InputGroup>
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                id="file-input"
                                name="identify_officerdoc2"
                                placeholder="Upload Kartu Identitas (Wajib diisi)"
                                accept="image/jpeg,image/png"
                                required
                              />
                            </InputGroup>
                            <span className="color-white mb-3">
                              *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                            </span>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <div className="page-links mt-4">
                              <a href="#." className="active">
                                Officer 3
                              </a>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-user"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="nama_officer3"
                                required
                                placeholder="Nama Officer 3 (Wajib diisi)"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-phone"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="number"
                                name="telp_officer3"
                                required
                                placeholder="No Telepon Officer 3 (Wajib diisi)"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="12" lg="6">
                            <Select
                              name="identify_officer3"
                              placeholder="-- Pilih Kartu Identitas (Wajib diisi) --"
                              value={identify_officer3}
                              onChange={this.onIdentityCard3}
                              options={identityCard3}
                              id="identify_officer3"
                              inputId="input_identify_officer3"
                              instanceId="instance_identify_officer3"
                            />
                          </Col>
                          <Col xs="12" sm="12" lg="6">
                            <InputGroup>
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                id="file-input"
                                name="identify_officerdoc3"
                                placeholder="Upload Kartu Identitas (Wajib diisi)"
                                accept="image/jpeg,image/png"
                                required
                              />
                            </InputGroup>
                            <span className="color-white mb-3">
                              *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                            </span>
                          </Col>
                        </Row>
                      </div>
                    )}

                    {this.state.form == FORM_SHIPPER && ( //new pmku
                      <div>
                        <Row className="mt-3">
                          <Col xs="6" sm="6" lg="6">
                            <label>Nomor Akta pendirian (Wajib diisi)</label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-file-text-o"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <NumberFormat
                                className="form-control"
                                // format="##.###.###.#-###.###"
                                // mask="_"
                                onValueChange={(values) => {
                                  const { formattedValue, value } = values;
                                  this.handleAktaPendirian(formattedValue);
                                }}
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="6" sm="6" lg="6">
                            <InputGroup className="mb-1">
                              <label>Upload Akta pendirian (Wajib diisi)</label>
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                id="file-input"
                                name="akta_pendirian_doc"
                                placeholder="Upload Akta pendirian"
                                accept="image/jpeg,image/png"
                                required
                              />
                            </InputGroup>
                            <span className="color-white mb-3">
                              *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                            </span>
                          </Col>
                        </Row>

                        <Row className="mt-3">
                          <Col xs="6" sm="6" lg="6">
                            <label>
                              Nomor Tanda Daftar Perusahaan (Wajib diisi)
                            </label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-file-text-o"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <NumberFormat
                                className="form-control"
                                // format="##.###.###.#-###.###"
                                // mask="_"
                                onValueChange={(values) => {
                                  const { formattedValue, value } = values;
                                  this.handleTDP(formattedValue);
                                }}
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="6" sm="6" lg="6">
                            <InputGroup className="mb-1">
                              <label>
                                Upload Tanda Daftar Perusahaan (Wajib diisi)
                              </label>
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                id="file-input"
                                name="tanda_daftar_perusahaan_doc"
                                placeholder="Upload Tanda Daftar perusahaan"
                                accept="image/jpeg,image/png"
                                required
                              />
                            </InputGroup>
                            <span className="color-white mb-3">
                              *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                            </span>
                          </Col>
                        </Row>

                        <Row className="mt-3">
                          <Col xs="6" sm="6" lg="6">
                            <label>
                              Nomor Surat Keterangan Domisili (Wajib diisi)
                            </label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-file-text-o"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <NumberFormat
                                className="form-control"
                                // format="##.###.###.#-###.###"
                                // mask="_"
                                onValueChange={(values) => {
                                  const { formattedValue, value } = values;
                                  this.handleSKD(formattedValue);
                                }}
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="6" sm="6" lg="6">
                            <InputGroup className="mb-1">
                              <label>
                                Upload Surat Keterangan Domisili (Wajib diisi)
                              </label>
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                id="file-input"
                                name="surat_keterangan_domisili_doc"
                                placeholder="Upload Surat keterangan domisili"
                                accept="image/jpeg,image/png"
                                required
                              />
                            </InputGroup>
                            <span className="color-white mb-3">
                              *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                            </span>
                          </Col>
                        </Row>

                        <Row className="mt-3">
                          <Col xs="6" sm="6" lg="6">
                            <label>
                              Nomor Surat penunjukan shipper (Wajib diisi)
                            </label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-file-text-o"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <NumberFormat
                                className="form-control"
                                // format="##.###.###.#-###.###"
                                // mask="_"
                                onValueChange={(values) => {
                                  const { formattedValue, value } = values;
                                  this.handleSPS(formattedValue);
                                }}
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="6" sm="6" lg="6">
                            <InputGroup className="mb-1">
                              <label>
                                Upload Surat penunjukan shipper (Wajib diisi)
                              </label>
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                id="file-input"
                                name="surat_penunjukan_shipper_doc"
                                placeholder="Upload Surat penunjukan shipper"
                                accept="image/jpeg,image/png"
                                required
                              />
                            </InputGroup>
                            <span className="color-white mb-3">
                              *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                            </span>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <div className="page-links mt-4">
                              <a href="#." className="active">
                                PMKU
                              </a>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-flag"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="no_pmku"
                                required
                                placeholder="Nomor PMKU (Wajib diisi)"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-flag"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="date"
                                name="tgl_pmku"
                                required
                                placeholder="Tanggal PMKU (Wajib diisi)"
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                      </div>
                    )}

                    {this.state.form == FORM_VESSEL_OP && (
                      <div>
                        <Row>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-1 mt-3">
                              <label>Logo Perusahaan (Wajib diisi)</label>
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                id="file-input"
                                name="logo_perusahaan"
                                placeholder="Upload Logo Perusahaan"
                                accept="image/jpeg,image/png"
                                required
                              />
                            </InputGroup>
                            <span className="color-white mb-3">
                              *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                            </span>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <div className="page-links mt-4">
                              <a href="#." className="active">
                                PMKU
                              </a>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-flag"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="no_pmku"
                                required
                                placeholder="Nomor PMKU (Wajib diisi)"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-flag"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="date"
                                name="tgl_pmku"
                                required
                                placeholder="Tanggal PMKU (Wajib diisi)"
                              />
                            </InputGroup>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <div className="page-links mt-4">
                              <a href="#." className="active">
                                Rekening
                              </a>
                            </div>
                          </Col>
                        </Row>

                        {this.state.banks.map((item, idx) => {
                          let bank = `bank-${idx}`;
                          let number = `number-${idx}`;
                          let name = `name-${idx}`;
                          this.countBank = idx + 1;

                          return (
                            <Row key={idx}>
                              <Col className="p-0">
                                <Col xs="12" sm="12" lg="12">
                                  <InputGroup className="mb-3">
                                    <InputGroupAddon addonType="prepend">
                                      <InputGroupText>
                                        <i className="fa fa-flag"></i>
                                      </InputGroupText>
                                    </InputGroupAddon>
                                    <AvInput
                                      type="text"
                                      name={bank}
                                      value={item.bank}
                                      onChange={this.onBankChange}
                                      required
                                      placeholder="Nama Bank (Wajib diisi)"
                                    />
                                  </InputGroup>
                                </Col>
                                <Col xs="12" sm="12" lg="12">
                                  <InputGroup className="mb-3">
                                    <InputGroupAddon addonType="prepend">
                                      <InputGroupText>
                                        <i className="fa fa-flag"></i>
                                      </InputGroupText>
                                    </InputGroupAddon>
                                    <AvInput
                                      type="text"
                                      name={number}
                                      value={item.number}
                                      onChange={this.onBankChange}
                                      required
                                      placeholder="Nomor Rekening (Wajib diisi)"
                                    />
                                  </InputGroup>
                                </Col>
                                <Col xs="12" sm="12" lg="12">
                                  <InputGroup className="mb-3">
                                    <InputGroupAddon addonType="prepend">
                                      <InputGroupText>
                                        <i className="fa fa-flag"></i>
                                      </InputGroupText>
                                    </InputGroupAddon>
                                    <AvInput
                                      type="text"
                                      name={name}
                                      value={item.name}
                                      onChange={this.onBankChange}
                                      required
                                      placeholder="Atas Nama (Wajib diisi)"
                                    />
                                  </InputGroup>
                                </Col>
                                <hr />
                              </Col>

                              <Col>
                                {this.state.bankAccountCount > 1 && (
                                  <Button
                                    size="md"
                                    className="btn-youtube"
                                    onClick={() => this.removeBank(idx)}
                                  >
                                    <i className="fa fa-trash mr-2"></i> Hapus{" "}
                                  </Button>
                                )}
                              </Col>
                            </Row>
                          );
                        })}

                        <Button
                          size="lg"
                          type="button"
                          onClick={() => this.addNewBankAccount(this.countBank)}
                          className="btn-success"
                        >
                          <i className="fa fa-plus mr-2"></i> Tambah Rekening
                          Bank Lainnya
                        </Button>

                        <Row>
                          <Col>
                            <div className="page-links mt-4">
                              <a href="#." className="active">
                                Akun bri
                              </a>
                            </div>
                          </Col>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-credit-card"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="virtual_account"
                                placeholder="Akun virtual"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-flag"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="institution_code"
                                placeholder="Kode institusi"
                              />
                            </InputGroup>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <div className="page-links mt-4">
                              <a href="#." className="active">
                                Kontrak
                              </a>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-flag"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="nomor_kontrak"
                                required
                                placeholder="Nomor Kontrak (Wajib diisi)"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="6" lg="6">
                            <label>Tanggal Awal Kontrak (Wajib diisi)</label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-calendar"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="date"
                                name="tanggal_awal_kontrak"
                                required
                                placeholder="Tanggal Awal Kontrak"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="6" lg="6">
                            <label>Tanggal Habis Kontrak (Wajib diisi)</label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-calendar"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="date"
                                name="tanggal_habis_kontrak"
                                required
                                placeholder="Tanggal Habis Kontrak"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-flag"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="addendum_kontrak"
                                placeholder="Addendum nomor kontrak"
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                      </div>
                    )}

                    {this.state.form == FORM_CONSIGNEE && (
                      <Row>
                        <Col xs="12" sm="12" lg="12">
                          <div className="page-links mt-4">
                            <a href="#." className="active">
                              Tipe Consignee{" "}
                            </a>
                          </div>
                        </Col>
                        <Col xs="12" sm="12" lg="12">
                          <InputGroup className="mb-1">
                            <AvInput
                              type="select"
                              id="file-input"
                              name="consignee_type"
                              onChange={(e) =>
                                this.setState({
                                  ...this.state,
                                  consignee_type: e.target.value,
                                  pakta_integritas: undefined,
                                })
                              }
                              required
                              placeholder="tipe consignee"
                            >
                              <option value={""}>
                                --pilih tipe consignee--
                              </option>
                              <option value={0}>Berangkat</option>
                              <option value={1}>Balik</option>
                            </AvInput>
                          </InputGroup>
                        </Col>
                        {this.state.consignee_type === "0" && (
                          <>
                            <Col xs="12" sm="12" lg="12">
                              <div className="page-links mt-4">
                                <a href="#." className="active">
                                  Pakta Integritas{" "}
                                </a>
                              </div>
                            </Col>
                            <Col xs="12" sm="12" lg="12">
                              <InputGroup className="mb-1">
                                <label>
                                  Upload Pakta Integritas (Wajib diisi)
                                </label>
                                <AvInput
                                  className="file-upload"
                                  onChange={this.handleFile}
                                  bsSize="xs"
                                  type="file"
                                  id="file-input"
                                  name="pakta_integritas"
                                  required
                                  placeholder="Upload Pakta Integritas"
                                  accept="image/jpeg,image/png"
                                />
                              </InputGroup>
                              <span className="color-white mb-3">
                                *JPG/JPEG/PNG/PDF Maksimal {MAX_UPLOAD}
                              </span>
                            </Col>
                          </>
                        )}
                        {/* <Col xs="12" sm="12" lg="12">
                          <div className="page-links mt-4">
                            <a href="#." className="active">Form Data Penjual</a>
                          </div>
                        </Col>
                        <Col xs="12" sm="12" lg="12">
                          <InputGroup className="mb-1">
                            <label>Upload Form Data Penjual</label>
                            <AvInput className="file-upload" onChange={this.handleFile} bsSize="xs" type="file" id="file-input" name="form_penjualan" placeholder="Upload Form Data Penjual" accept="image/jpeg,image/png" />
                          </InputGroup>
                          <span className="color-white mb-3">*JPG/JPEG/PNG Maksimal {MAX_UPLOAD}</span>
                        </Col> */}
                      </Row>
                    )}

                    {(this.state.form == FORM_SUPPLIER ||
                      this.state.form == FORM_RESELLER) && (
                      <Row>
                        <Col xs="12" sm="12" lg="12">
                          <div className="page-links mt-4">
                            <a href="#." className="active">
                              Tipe {this.state.form}{" "}
                            </a>
                          </div>
                        </Col>
                        <Col xs="12" sm="12" lg="12">
                          <InputGroup className="mb-1">
                            <AvInput
                              type="select"
                              id="file-input"
                              name={`${this.state.form}_type`}
                              onChange={(e) =>
                                this.setState({
                                  ...this.state,
                                  [`${this.state.form}_type`]: e.target.value,
                                  form_penjualan: undefined,
                                  pakta_integritas: undefined,
                                })
                              }
                              required
                              placeholder={`tipe ${this.state.form}`}
                            >
                              <option value={""}>
                                --pilih tipe {this.state.form}--
                              </option>
                              <option value={0}>Berangkat</option>
                              <option value={1}>Balik</option>
                            </AvInput>
                          </InputGroup>
                        </Col>
                        {this.state.form != FORM_SUPPLIER &&
                          this.state.reseller_type === "0" && (
                            <>
                              <Col xs="12" sm="12" lg="12">
                                <div className="page-links mt-4">
                                  <a href="#." className="active">
                                    Pakta Integritas{" "}
                                  </a>
                                </div>
                              </Col>
                              <Col xs="12" sm="12" lg="12">
                                <InputGroup className="mb-1">
                                  <label>Upload Pakta Integritas</label>
                                  <AvInput
                                    className="file-upload"
                                    onChange={this.handleFile}
                                    bsSize="xs"
                                    type="file"
                                    id="file-input"
                                    name="pakta_integritas"
                                    placeholder="Upload Pakta Integritas"
                                    accept="image/jpeg,image/png"
                                  />
                                </InputGroup>
                                <span className="color-white mb-3">
                                  *JPG/JPEG/PNG/PDF Maksimal {MAX_UPLOAD}
                                </span>
                              </Col>
                            </>
                          )}
                      </Row>
                    )}

                    {this.state.form == FORM_SUPPLIER &&
                      this.state.supplier_type === "1" && (
                        <Row>
                          <Col xs="12" sm="12" lg="12">
                            <div className="page-links mt-4">
                              <a href="#." className="active">
                                Form Data Penjual
                              </a>
                            </div>
                          </Col>
                          <Col xs="12" sm="12" lg="12">
                            <InputGroup className="mb-1">
                              <label>
                                Upload Form Data Penjual (Wajib diisi)
                              </label>
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                id="file-input"
                                name="form_penjualan"
                                required
                                placeholder="Upload Form Data Penjual"
                                accept="image/jpeg,image/png"
                              />
                            </InputGroup>
                            <span className="color-white mb-3">
                              *JPG/JPEG/PNG/PDF Maksimal {MAX_UPLOAD}
                            </span>
                          </Col>
                        </Row>
                      )}

                    <Row>
                      <Col>
                        <div className="page-links mt-4">
                          <a href="#." className="active">
                            Data PIC
                          </a>
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs="12" sm="6" lg="6">
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="fa fa-user"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <AvInput
                            type="text"
                            name="nama_pic"
                            required
                            placeholder="Nama PIC (Wajib diisi)"
                          />
                        </InputGroup>
                      </Col>
                      <Col xs="12" sm="6" lg="6">
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="icon-envelope"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <AvInput
                            type="email"
                            name="email_pic"
                            required
                            placeholder="Email PIC (Wajib diisi)"
                          />
                        </InputGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs="12" sm="6" lg="6">
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="fa fa-mobile-phone"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <AvInput
                            type="number"
                            name="hp_pic"
                            required
                            placeholder="No HP (Wajib diisi)"
                          />
                        </InputGroup>
                      </Col>
                      <Col xs="12" sm="6" lg="6">
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="fa fa-phone"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <AvInput
                            type="text"
                            name="telp_pic"
                            required
                            placeholder="No Tlp PIC (Wajib diisi)"
                          />
                        </InputGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs="12" sm="6" lg="6">
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="fa fa-fax"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <AvInput
                            type="text"
                            name="fax_pic"
                            required
                            placeholder="Fax PIC (Wajib diisi)"
                          />
                        </InputGroup>
                      </Col>
                    </Row>

                    {this.state.region_msg && (
                      <div className="alert alert-danger mt-4">
                        {this.state.region_msg}
                      </div>
                    )}

                    <hr />

                    <span>
                      <h6>
                        <input
                          name="agreement"
                          type="checkbox"
                          checked={this.state.isAgree}
                          onChange={this.handleIsAgree}
                        />
                        <div style={{ color: "#ffff", marginLeft: "25px" }}>
                          Saya setuju untuk tidak memberikan data akun ke pihak
                          lain, dan jika terjadi kehilangan data, maka pihak
                          Regulator tidak bertanggung jawab atas hal tersebut.
                        </div>
                      </h6>
                    </span>

                    {/* 
                    <AvCheckboxGroup name="agreement" className="agreement" required>
                      <AvCheckbox customInput label="Saya setuju untuk tidak memberikan data akun ke pihak lain, dan jika terjadi kehilangan data, maka pihak Regulator tidak bertanggung jawab atas hal tersebut." value="agreement" />
                    </AvCheckboxGroup> 
                    */}

                    <div className="form-button">
                      <Button
                        id="submit"
                        size="lg"
                        type="submit"
                        className="btn-success"
                        disabled={
                          // this.state.npwp &&
                          this.state.isAgree && this.state.loading === false
                            ? false
                            : true
                        }
                      >
                        {this.state.loading ? (
                          <Spinner size="sm" color="secondary" />
                        ) : (
                          "Submit"
                        )}
                      </Button>
                      <Button
                        size="lg"
                        type="button"
                        onClick={() => this.onCancel()}
                        className="btn-warning"
                      >
                        Batal
                      </Button>
                    </div>
                  </AvForm>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      const stealthy = {
        left: 0,
        margin: 0,
        maxHeight: "1px",
        maxWidth: "1px",
        opacity: 0,
        outline: "none",
        overflow: "hidden",
        pointerEvents: "none",
        position: "absolute",
        top: 0,
        zIndex: -1,
      };

      return (
        <div className="form-body">
          <div className="row">
            <div className="img-holder">
              <div className="bg"></div>
              <div className="info-holder">
                <div className="image-center">
                  <img src={logo} width="100" height="50" alt="" />
                </div>
                <h3>Sistem Informasi Tol Laut.</h3>
                <p>Access to the most powerfull tool in this aplication.</p>
              </div>
            </div>
            <div className="form-holder">
              <div className="form-content">
                <div className="form-items">
                  <div className="website-logo-inside">
                    <div className="logo">
                      <h1>Register</h1>
                    </div>
                  </div>
                  <div className="page-links">
                    <a href="/login">Login</a>
                    <Link to={"/register"} className="active">
                      Register
                    </Link>
                    {/* <a href="/register" className="active">Register</a> */}
                  </div>
                  {this.props.isLoading && (
                    <div className="alert alert-info alert-login" role="alert">
                      Loading ....
                    </div>
                  )}
                  {this.props.hasError && (
                    <div
                      className="alert alert-danger alert-login"
                      role="alert"
                    >
                      Email for this user type is exist, please use other email
                    </div>
                  )}
                  {this.props.checkError && this.props.check_data && (
                    <div
                      className="alert alert-danger alert-login"
                      role="alert"
                    >
                      {this.props.check_data.message}
                    </div>
                  )}
                  {(this.state.passwordNotification ||
                    this.state.registrationError) && (
                    <Alert color="danger">
                      {this.state.passwordNotification ||
                        this.state.registrationError}
                    </Alert>
                  )}
                  <AvForm onValidSubmit={this.handleSubmit}>
                    <input
                      type="email"
                      style={stealthy}
                      name="mail"
                      tabIndex="-1"
                    />
                    <Select
                      name="usery_type_id"
                      className="mb-3"
                      placeholder="-- Jenis User --"
                      styles={{
                        container: (base) => ({
                          ...base,
                          display: "none",
                        }),
                      }}
                    />

                    <CreatableSelect
                      name="source_id"
                      required
                      className="mb-3"
                      style={{ height: "64px" }}
                      placeholder="Dari mana anda mendapatkan info tentang SITOLAUT ?"
                      value={this.state.source_id}
                      onChange={this.selectSource}
                      options={this.state.source}
                    />

                    <Select
                      name="usery_type_id"
                      required
                      className="mb-3"
                      placeholder="-- Jenis User --"
                      value={usery_type_id}
                      onChange={this.selectOption}
                      options={this.state.user_types}
                    />

                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-envelope"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <AvInput
                        type="email"
                        name="email"
                        required
                        placeholder="Email"
                        autoComplete="email"
                      />
                    </InputGroup>

                    {/* <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-lock"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <input
                        type="password"
                        name="fake1"
                        style={stealthy}
                        tabIndex="-1"
                      />
                      <AvInput
                        type="password"
                        name="password"
                        required
                        placeholder="Password"
                        autoComplete="off"
                      />
                      <input
                        type="password"
                        name="fake2"
                        style={stealthy}
                        tabIndex="-1"
                      />
                    </InputGroup>

                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-lock"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <input
                        type="password"
                        name="fake1"
                        style={stealthy}
                        tabIndex="-1"
                      />
                      <AvInput
                        type="password"
                        name="confirm_password"
                        required
                        placeholder="Konfirmasi Password"
                        autoComplete="off"
                      />
                      <input
                        type="password"
                        name="fake2"
                        style={stealthy}
                        tabIndex="-1"
                      />
                    </InputGroup> */}

                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-lock"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <AvInput
                        type={this.state.showPassword ? "text" : "password"}
                        name="password"
                        value={this.state.password}
                        // onChange={(e) =>
                        //   this.setState({ password: e.target.value })
                        // }
                        onChange={this.handlePasswordChange}
                        required
                        placeholder="Password"
                        autoComplete="off"
                      />

                      <InputGroupAddon
                        addonType="append"
                        className="eye-button"
                      >
                        <InputGroupText
                          style={{ border: 0, backgroundColor: "white" }}
                          onClick={this.togglePasswordVisibility}
                        >
                          <i
                            className={`fa ${
                              this.state.showPassword
                                ? "fa-eye"
                                : "fa-eye-slash"
                            }`}
                          ></i>
                        </InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>

                    {(!this.state.password || this.state.passwordStrength) && (
                      <Alert
                        color={
                          this.state.passwordStrength === "kuat"
                            ? "success"
                            : this.state.password === ""
                            ? "warning"
                            : this.state.passwordStrength === "lemah"
                            ? "danger"
                            : "warning"
                        }
                      >
                        {this.state.password === "" ? (
                          "Password harus terdiri dari minimal 8 karakter, huruf besar, huruf kecil, angka, dan simbol."
                        ) : (
                          <>Kekuatan Password: {this.state.passwordStrength}</>
                        )}
                      </Alert>
                    )}

                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-lock"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <AvInput
                        type={
                          this.state.showConfirmPassword ? "text" : "password"
                        }
                        value={this.state.confirm_password}
                        validate={{ match: { value: "password" } }}
                        name="confirm_password"
                        required
                        placeholder="Konfirmasi Password"
                        autoComplete="off"
                      />
                      <InputGroupAddon
                        addonType="append"
                        className="eye-button"
                      >
                        <InputGroupText
                          style={{ border: 0, backgroundColor: "white" }}
                          onClick={this.toggleConfirmPasswordVisibility}
                        >
                          <i
                            className={`fa ${
                              this.state.showConfirmPassword
                                ? "fa-eye"
                                : "fa-eye-slash"
                            }`}
                          ></i>
                        </InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>

                    <div className="form-button">
                      <button
                        id="submit"
                        type="submit"
                        disabled={
                          btnDisabled === true
                            ? true
                            : this.props.checkLoading === true
                            ? true
                            : false
                        }
                        className="ibtn"
                      >
                        {this.props.checkLoading === true && (
                          <>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />{" "}
                          </>
                        )}
                        Register
                      </button>
                      <div className="float-right mt-2">
                        <Link to="forgot-password">Lupa Password?</Link>
                      </div>
                    </div>
                  </AvForm>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

Register.propTypes = {
  isSuccess: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,

  consigneeIsSuccess: PropTypes.bool.isRequired,
  consigneeHasError: PropTypes.bool.isRequired,
  consigneeIsLoading: PropTypes.bool.isRequired,
  consigneeIsInvalid: PropTypes.bool.isRequired,

  supplierIsSuccess: PropTypes.bool.isRequired,
  supplierHasError: PropTypes.bool.isRequired,
  supplierIsLoading: PropTypes.bool.isRequired,
  supplierIsInvalid: PropTypes.bool.isRequired,

  shipperIsSuccess: PropTypes.bool.isRequired,
  shipperHasError: PropTypes.bool.isRequired,
  shipperIsLoading: PropTypes.bool.isRequired,
  shipperIsInvalid: PropTypes.bool.isRequired,

  resellerIsSuccess: PropTypes.bool.isRequired,
  resellerHasError: PropTypes.bool.isRequired,
  resellerIsLoading: PropTypes.bool.isRequired,
  resellerIsInvalid: PropTypes.bool.isRequired,

  operatorIsSuccess: PropTypes.bool.isRequired,
  operatorHasError: PropTypes.bool.isRequired,
  operatorIsLoading: PropTypes.bool.isRequired,
  operatorIsInvalid: PropTypes.bool.isRequired,

  provinsiIsSuccess: PropTypes.bool.isRequired,
  provinsiHasError: PropTypes.bool.isRequired,
  provinsiIsLoading: PropTypes.bool.isRequired,

  kotaIsSuccess: PropTypes.bool.isRequired,
  kotaHasError: PropTypes.bool.isRequired,
  kotaIsLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    account: state.auth.account,
    isSuccess: state.auth.authRegisterSuccess,
    hasError: state.auth.authRegisterError,
    isLoading: state.auth.authRegisterLoading,

    check_data: state.auth.check_data,
    checkSuccess: state.auth.authRegisterCheckSuccess,
    checkError: state.auth.authRegisterCheckError,
    checkLoading: state.auth.authRegisterCheckLoading,

    consigneeIsSuccess: state.consignees.consigneeAddSuccess,
    consigneeHasError: state.consignees.consigneeAddError,
    consigneeIsLoading: state.consignees.consigneeAddLoading,
    consigneeIsInvalid: state.consignees.consigneeAddInvalid,
    consigneeInvalid: state.consignees.invalid,

    supplierIsSuccess: state.suppliers.supplierAddSuccess,
    supplierHasError: state.suppliers.supplierAddError,
    supplierIsLoading: state.suppliers.supplierAddLoading,
    supplierIsInvalid: state.suppliers.supplierAddInvalid,
    supplierInvalid: state.suppliers.invalid,

    shipperIsSuccess: state.shippers.shipperAddSuccess,
    shipperHasError: state.shippers.shipperAddError,
    shipperIsLoading: state.shippers.shipperAddLoading,
    shipperIsInvalid: state.shippers.shipperAddInvalid,
    shipperInvalid: state.shippers.invalid,

    resellerIsSuccess: state.resellers.resellerAddSuccess,
    resellerHasError: state.resellers.resellerAddError,
    resellerIsLoading: state.resellers.resellerAddLoading,
    resellerIsInvalid: state.resellers.resellerAddInvalid,
    resellerInvalid: state.resellers.invalid,

    operatorIsSuccess: state.operators.operatorAddSuccess,
    operatorHasError: state.operators.operatorAddError,
    operatorIsLoading: state.operators.operatorAddLoading,
    operatorIsInvalid: state.operators.operatorAddInvalid,
    operatorInvalid: state.operators.invalid,

    provinsis: state.provinsis.provinsis,
    provinsiIsSuccess: state.provinsis.provinsiGetSuccess,
    provinsiHasError: state.provinsis.provinsiGetError,
    provinsiIsLoading: state.provinsis.provinsiGetLoading,

    kotas: state.kotas.kotas,
    kotaIsSuccess: state.kotas.kotaGetSuccess,
    kotaHasError: state.kotas.kotaGetError,
    kotaIsLoading: state.kotas.kotaGetLoading,

    roles: state.roles.roles,
    rolesIsSuccess: state.roles.roleGetSuccess,

    userSource: state.userSource.list,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doRegister: (parent) => dispatch(doRegister(parent)),
    doRegisterCheck: (data) => dispatch(doRegisterCheck(data)),
    consigneeAdd: (parent) => dispatch(consigneeAdd(parent)),
    supplierAdd: (parent) => dispatch(supplierAdd(parent)),
    resellerAdd: (parent) => dispatch(resellerAdd(parent)),
    shipperAdd: (parent) => dispatch(shipperAdd(parent)),
    operatorAdd: (parent) => dispatch(operatorAdd(parent)),
    provinsiFetchAll: (parent) => dispatch(provinsiFetchAll(parent)),
    kotaFetchSub: (parent) => dispatch(kotaFetchSub(parent)),
    roleFetchAll: (data) => dispatch(roleFetchAll(data)),
    userSourceFetchAll: () => dispatch(userSourceFetchAll()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
